import { Transaction, VendingHistoryStep } from "../../../../model/transaction";

// Backend VendingStep enum values
export enum VendingStepType {
	UNKNOWN = 0,
	PAYMENT = 1,
	TOKEN_GENERATION = 2,
	SMS_EMAIL_DELIVERY = 3,
	REMOTE_LOAD = 4,
}

// Backend VendingStepStatus enum values
export enum VendingStepStatus {
	UNKNOWN = 0,
	PENDING = 1,
	SUCCESSFUL = 2,
	FAILED = 3,
	SKIPPED = 4,
}

// UI Timeline step status
export type TimelineStepStatus = 'completed' | 'pending' | 'failed' | 'skipped' | 'idle';

// UI Timeline step (mapped from backend data)
export interface TimelineStep {
	id: string;                      // Unique step identifier
	typeOfEvent: VendingStepType;    // Backend step type
	label: string;                   // Display label
	status: TimelineStepStatus;      // UI status
	timestamp?: string;              // When step occurred
	timeFormated?: string;           // Formatted timestamp for display
	content?: React.ReactNode;       // Expandable content (e.g., token display)
}

// Component props
export interface TransactionResultV2Props {
	transaction?: Transaction;
	isLoading?: boolean;
	onContinue: () => void;
	onCancel?: () => void;
	currency?: string;
	onReportIssue?: () => void;
	paymentMethod?: string;
	onSaveBeneficiary?: () => Promise<void> | void;
	isBeneficiarySaved?: boolean;
	isSavingBeneficiary?: boolean;
	onRevendToken?: () => Promise<void> | void;
	isRevending?: boolean;
	onDownloadReceipt?: () => Promise<void> | void;
	isDownloadingReceipt?: boolean;
	onShareReceipt?: () => Promise<void> | void;
	feePaid?: number;
}

// Subcomponent props
export interface TransactionHeaderProps {
	status: 'success' | 'failed' | 'pending';
	title: string;
	subtitle?: string;
}

export interface TransactionTimelineProps {
	steps: TimelineStep[];
	isMobile: boolean;
}

export interface TokenDisplayProps {
	token: string;
	onTransfer?: () => void;
}

export interface TransactionDetailsProps {
	transaction: Transaction;
	currency: string;
	paymentMethod?: string;
}

// Export VendingHistoryStep for convenience
export type { VendingHistoryStep };
